import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { BodyBuilder } from "../../../../exports/Images";
import BorderedButton from "../../../payouts-wtf/common/BorderedButton";
import { changeTrainerShiftDays } from "../../../../redux/reducers/postApiSlice";
const ManageTrainerShiftDays = ({
  decryptedText,
  trainerInfo,
  initialAction,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const shiftDaysArray = trainerInfo?.actionData?.shift_days?.split(",") || [];

  const initialCheckboxState = daysOfWeek.map((day, index) => ({
    id: index + 1,
    name: day.toLowerCase(),
    checked: shiftDaysArray.includes(day.slice(0, 3)),
  }));

  const [checkboxState, setCheckboxState] = useState(initialCheckboxState);
  const [days, setDays] = useState(shiftDaysArray);
  const [isAPICall, setIsAPICall] = useState(false);

  // const onChangeCheckbox = (event) => {
  //   setIsAPICall(false);

  //   const { name, checked } = event.target;
  //   setCheckboxState((prevCheckboxState) =>
  //     prevCheckboxState.map((checkbox) =>
  //       checkbox.name === name ? { ...checkbox, checked } : checkbox
  //     )
  //   );

  //   setDays((prevDays) => {
  //     if (checked) {
  //       return [...prevDays, name];
  //     } else {
  //       return prevDays.filter((day) => day !== name);
  //     }
  //   });
  // };

  const onChangeCheckbox = (event) => {
    setIsAPICall(false);

    const { name, checked } = event.target;
    setCheckboxState((prevCheckboxState) =>
      prevCheckboxState.map((checkbox) =>
        checkbox.name === name ? { ...checkbox, checked } : checkbox
      )
    );

    setDays((prevDays) => {
      if (checked) {
        return [...prevDays, name];
      } else {
        return prevDays.filter((day) => day !== name);
      }
    });
  };

  const handleSubmit = async (userData, TOKEN) => {
    setIsAPICall(false);

    try {
      const actionResult = dispatch(
        changeTrainerShiftDays({ userData, TOKEN })
      );
      const result = await actionResult;

      if (result.payload.status) {
        toast.success(result.payload?.message || "Success!");
        initialAction();
        setCheckboxState(initialCheckboxState);
        setDays([]);
        callFunction();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("changeTrainerShiftDays ERROR => ", error);
    }
  };

  const onSubmitShifts = (e) => {
    e.preventDefault();

    if (!trainerInfo?.userId) {
      setIsAPICall(false);
      toast.error("User ID not found!");
    } else {
      setIsAPICall(true);
    }
  };

  useEffect(() => {
    if (isAPICall) {
      const userData = {
        user_id: trainerInfo.userId,
        days: days,
      };

      handleSubmit(userData, decryptedText?.token);
    }
  }, [isAPICall, days]);

  return (
    <div className="manageShiftContainer daysShiftContainer">
      {/* <ToastContainer /> */}
      <div className="infoContainer">
        <div className="imgContainer">
          <img src={BodyBuilder} alt={trainerInfo?.actionData?.name || "NA"} />
        </div>
        <div className="informationContainer">
          <p className="name">{trainerInfo?.actionData?.name || "NA"}</p>
          <span className="detail">Trainer</span>
        </div>
      </div>

      <form className="shiftDetailContainer">
        <div className="shiftBox">
          {daysOfWeek.map((day, index) => (
            <div className="inputBox" key={index}>
              <div className="input-group checkBoxInputBox">
                <input
                  type="checkbox"
                  className="checkBoxInput"
                  name={day.toLowerCase()}
                  checked={checkboxState[index].checked}
                  value={checkboxState[index].checked}
                  onChange={onChangeCheckbox}
                />
              </div>
              <label htmlFor={day.toLowerCase()}>{day.slice(0, 3)}</label>
            </div>
          ))}
        </div>
      </form>

      <div className="buttonContainer lastFlex padded">
        <BorderedButton
          buttonText="Submit"
          onClickButton={onSubmitShifts}
          isDisabled={false}
        />
      </div>
    </div>
  );
};

export default ManageTrainerShiftDays;
